import { render, staticRenderFns } from "./ServiceHallByMatter.vue?vue&type=template&id=6a44cd94&scoped=true&"
import script from "./ServiceHallByMatter.vue?vue&type=script&lang=js&"
export * from "./ServiceHallByMatter.vue?vue&type=script&lang=js&"
import style0 from "./ServiceHallByMatter.vue?vue&type=style&index=0&id=6a44cd94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a44cd94",
  null
  
)

export default component.exports